import config from '@config';

import createDataSource from './createDataSource';

const BASE_PATHNAME = 'indexer';

export default () => {
  const dataSource = createDataSource(config.api.url);

  const reindex = ({ name }) =>
    dataSource
      .post(BASE_PATHNAME, {
        body: JSON.stringify({ name }),
        headers: {
          'Content-Type': 'text/json',
        },
      })
      .text();

  return {
    reindex,
  };
};
